module.exports = __webpack_public_path__ + "img/aboutBanner.d8523552.png";